import { ImageListIF } from '@/components/widgets/AddPhotoWidget/MakePhotoBetterInfoModal/MakePhotoBetterInfoModal.types';

export const IMAGES_LIST: ImageListIF[] = [
    {
        guid: '6c3f4260-70fa-48cd-994c-a26a6dbe93fb',
        isLike: false,
    },
    {
        guid: '1d39ee2f-f2ee-4bf2-896a-1b7c0033b64f',
        isLike: true,
    },
];
